'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'envelope-open-dollar';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f657';
var svgPathData = 'M96.4 175.8L288 33.9 479.6 175.8 321.5 293c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L96.4 175.8zM288-32c-12.1 0-23.8 3.9-33.5 11L57.9 124.7C41.6 136.8 32 155.8 32 176.1L32 416c0 35.3 28.7 64 64 64l308.1 0c.8-13.9 5.8-26.6 13.7-37-13.7-17.3-21.8-39-21.8-62.5 0-42.1 25.9-78.2 62.7-93.1 12.1-18.8 33.2-31.3 57.3-31.3 10 0 19.5 2.2 28 6l0-85.9c0-20.3-9.6-39.4-25.9-51.4L321.5-21c-9.7-7.2-21.4-11-33.5-11zM516 304c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L472 464c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeOpenDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;